import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Button } from 'react-materialize';
import moment from 'moment';
import { FormattedMessage, injectIntl } from 'react-intl';

import Logger from '../functions/logging';

import Active from '../components/home/Active';
import MyList from '../components/home/MyList';
import Profile from '../components/home/Profile';
import Rewards from '../components/home/Rewards';
import PageLoader from '../components/global/PageLoader';
import { Errors } from '../components/global/Messages';

/* Google analytics */
import ActionStatus from '../analytics/analytics-events/ActionStatus';
import { ActionStatusEvent } from '../analytics/analytics-events/constants';

import '../static/home/Home.css';

import SmallWhitePilotlyLogo from '../assets/landing/SmallWhitePilotlyLogo';
// import userDefaultIcon from '../assets/home/user-default-icon.png';
import signOutIcon from '../assets/home/sign-out-icon.png';
// import happyDayIcon from '../assets/home/happy-day.png';

import { calculatePoints } from '../functions/rewards';
// import { formatDuration } from '../functions/time';
import { getUser, getUserMonitor } from '../api/user';
import { getActivityGroups, getSubscribedGroups } from '../api/groups';

import FadeIn from '../components/global/FadeIn';
import * as authFns from '../functions/auth';
import * as TargetProcess from '../functions/targetProcess';
// import * as homeFns from '../functions/home';
import * as studyFns from '../functions/study';

import localeMessages from '../locales/home';

import {
	setCurrentUser,
	setActivityList,
	setMyList,
	setPilotlyPoints,
	setUserMonitor,

	setTargetParams,
	setFetchedDistributionList,
	setFetchedGroup,
	setFetchedGroupPanelSegment,
	setFetchedEpisode
} from '../redux/actions/index';

class Home extends Component {
	constructor(props) {
		super(props);

		let userLoading = false;
		let user_token = authFns.getToken();
		if (user_token && !props.currentUser) {
			userLoading = true;
		}

		this.state = {
			errors: {},
			userLoading: userLoading,
			userMonitorLoading: true,
			activityListLoading: true,
			myListLoading: true,
			apiCalled: false,
			
			confirmSignOutVisible: false,
			isThirdPartyUser: false
		};

		// this.validate = this.validate.bind(this);
		// this.submit = this.submit.bind(this);
		// this.handleChange = this.handleChange.bind(this);
	}

	// static getDerivedStateFromProps(nextProps, prevState) {
	// 	Logger.log("getDerivedStateFromProps()", nextProps, prevState);
	// 	return null;
	// }

	componentDidMount() {
		Logger.log(this.constructor.name, "componentDidMount()", this.props, this.state);
		let user_token = authFns.getToken();
		if (user_token) this.loadUser(user_token);
		this.clearStudyReduxProps();
		authFns.checkThirdPartyEndDate();

		let thirdPartyUrl = authFns.getThirdPartyUrl();
		if (thirdPartyUrl) this.props.history.push(thirdPartyUrl);


		// if partner user, redirect away

	}

	componentDidUpdate() {
		let user_token = authFns.getToken();
		if (this.props.currentUser && user_token && !this.state.apiCalled) {
			this.setState({ apiCalled: true }, () => {
				this.loadActivityGroups(user_token);
				this.loadSubscribedGroups(this.props.currentUser, user_token);
				this.loadUserMonitor(this.props.currentUser.user_id, user_token);
			});
		}

		let isThirdPartyUser = TargetProcess.isThirdPartyUser(this.props.currentUser);
		if(isThirdPartyUser) { this.props.history.push('/'); }
	}

	async loadUser(user_token) {
		Logger.log(this.constructor.name, "loadUser()", user_token);
		try {
			const result = await getUser(user_token);
			if (result) {
				Logger.log(this.constructor.name, "loadUser() result", result);
				this.props.setCurrentUser(result);
				this.setState({ userLoading: false });
			}
			else {
				Logger.error(this.constructor.name, "loadUser(): User Failed: No result token???");
				let errors = { ...this.state.errors };
				errors["reason"] = this.props.intl.formatMessage(localeMessages.home_error_loading_user);
				this.setState({ errors, userLoading: false });
			}
		}
		catch (error) {
			let errors = { ...this.state.errors };
			Logger.error(this.constructor.name, "loadUser() User Failed", error);
			errors["status"] = this.props.intl.formatMessage(localeMessages.home_error_loading_user);
			this.setState({ errors, userLoading: false });
		}
	}

	async loadActivityGroups(user_token) {
		try {
			const result = await getActivityGroups(user_token);
			if (result) {
				this.props.setActivityList(result);
				this.setState({ activityListLoading: false });
			}
			else {
				Logger.log(this.constructor.name, "loadActivityGroups() err: No result token???");
				let errors = { ...this.state.errors };
				errors["reason"] = this.props.intl.formatMessage(localeMessages.home_error_loading_studies);
				this.setState({ errors, activityListLoading: false });
			}
		}
		catch (error) {
			let errors = { ...this.state.errors };
			Logger.error(this.constructor.name, "loadActivityGroups() err", error);
			errors["status"] = this.props.intl.formatMessage(localeMessages.home_error_loading_studies);
			this.setState({ errors, activityListLoading: false });
		}
	}

	async loadSubscribedGroups(currentUser, user_token) {
		try {
			const result = await getSubscribedGroups(user_token);
			if (result) {
				Logger.log(this.constructor.name, "loadSubscribedGroups() result", result);
				this.setupMyList(result);
				this.setState({ myListLoading: false });
			}
			else {
				Logger.log(this.constructor.name, "loadSubscribedGroups() err: No result token???");
				let errors = { ...this.state.errors };
				errors["reason"] = this.props.intl.formatMessage(localeMessages.home_error_loading_studies);
				this.setState({ errors, myListLoading: false });
			}
		}
		catch (error) {
			let errors = { ...this.state.errors };
			Logger.error(this.constructor.name, "loadSubscribedGroups() err", error);
			errors["status"] = this.props.intl.formatMessage(localeMessages.home_error_loading_studies);
			this.setState({ errors, myListLoading: false });
		}
	}

	async loadUserMonitor(user_id, user_token) {
		Logger.log(this.constructor.name, "getUserMonitor(): USER TOKEN: " + user_token + " USER_ID: " + user_id);

		try {
			const results = await getUserMonitor(user_id, user_token);
			if (results) {
				Logger.log(this.constructor.name, "GET User Monitor Successful", results);
				this.props.setUserMonitor(results);
				this.setState({ userMonitorLoading: false });
			}
			else {
				Logger.log(this.constructor.name, "GET User Monitor: No result token/user_id???");
				let errors = { ...this.state.errors };
				errors["status"] = this.props.intl.formatMessage(localeMessages.home_error_loading_user);
				this.setState({ errors: errors, userMonitorLoading: false });

			}
		}
		catch (error) {
			let errors = { ...this.state.errors };
			Logger.log(this.constructor.name, "GET User Monitor Failed", error);
			errors["status"] = this.props.intl.formatMessage(localeMessages.home_error_loading_user);
			this.setState({ errors: errors, userMonitorLoading: false });
		}
	}

	clearStudyReduxProps() {
		this.props.setTargetParams(null);
		this.props.setFetchedDistributionList(null);
		this.props.setFetchedGroup(null);
		this.props.setFetchedGroupPanelSegment(null);
		this.props.setFetchedEpisode(null);
	}

	setupMyList(userStudies) {
		let myList = [];
		let pilotlyPointsTotal = 0;

		if (userStudies && userStudies.length) {
			userStudies.forEach(study => {
				if (!studyFns.isUserScreened(study)) {
					pilotlyPointsTotal += study.userData.complete ? calculatePoints(study) : 0;
					myList.push(study);
				}
			});
		}

		this.props.setPilotlyPoints(pilotlyPointsTotal);
		this.props.setMyList(myList);
		this.setState({ myListLoading: false });
	}

	confirmSignOut() {
		this.setState({ confirmSignOutVisible: true });
	}

	cancelSignOut() {
		this.setState({ confirmSignOutVisible: false });
	}

	signOut() {
		let actionStatus = new ActionStatus(ActionStatusEvent.AUTH_LOGOUT, '', '', false, false, true);
		actionStatus.view = 'Home';
		actionStatus.gaTracker = this.props.tracker;
		this.props.globalAnalyticsAdapter.reportAnalyticsEvent(actionStatus);	
		this.props.history.push('/logout');
	}

	closeMessages() {
		this.setState({ errors: {} });
	}

	renderUserIcon(currentUser) {
		let firstNameInitial = currentUser && currentUser.firstname ? currentUser.firstname[0].toLowerCase() : <i className="fas fa-user"></i>;
		return(
			<div className="pilotly-home-profile-icon">{firstNameInitial}</div>
		);
	}

	render() {
		Logger.log(this.constructor.name, "render()", this.props, this.state);

		const pageReady = !this.state.userLoading;

		let active = null;
		let content = null;
		if (pageReady) {
			switch (this.props.location.pathname) {
				case "/mylist": {
					active = "myList";
					content = <MyList {...this.props} />;
					break;
				}
				case "/rewards": {
					active = "rewards";
					content = <Rewards {...this.props} />;
					break;
				}
				case "/profile": {
					active = "profile";
					content = <Profile {...this.props} />;
					break;
				}
				default: {
					active = null;
					content = <Active {...this.props} userMonitorLoading={this.state.userMonitorLoading} />;
					break;
				}
			}
		}

		let userIcon = this.renderUserIcon(this.props.currentUser, active);

		// INTL:DATE
		const dayOfWeek = moment().format('dddd');
		let welcomeMessage = "Happy " + dayOfWeek + "!";
		if (this.props.currentUser && this.props.currentUser.firstname && this.props.currentUser.firstname.length < 20) {
			welcomeMessage = "Happy " + dayOfWeek + ", " + this.props.currentUser.firstname + "!";
		}

		if (!Object.keys(this.state.errors).length && (this.state.userLoading || this.state.userMonitorLoading || this.state.activityListLoading || this.state.myListLoading)) {
			return (
				<div className="pilotly-home">
					<PageLoader addedClass="pilotly-blue-background" loading={true} small={true} />
				</div>
			);
		}

		return (
			<FadeIn>
				<div className="pilotly-home">
					<div className="pilotly-home-left">
						<div className="pilotly-home-left-container">
							<div className="pilotly-home-header">
								<div className="pilotly-home-logo">
									<Link to='/home' className='noselect'>
										<img className='pilotly-home-logo-image' src={SmallWhitePilotlyLogo} alt='Pilotly' />
									</Link>
								</div>
								<div className="pilotly-home-menu">
									<div className={"pilotly-home-menu-list" + (active === 'myList' ? " active" : "")}>
										<Link to='/mylist' className='noselect'>
											<FormattedMessage
												id="home.menu.my_list"
												defaultMessage={"My List"}
											/>
										</Link>
									</div>
									<div className={"pilotly-home-menu-rewards" + (active === 'rewards' ? " active" : "")}>
										<Link to='/rewards' className='noselect'>
											<FormattedMessage
												id="home.menu.rewards"
												defaultMessage={"Rewards"}
											/>
										</Link>
									</div>
								</div>
								<div className={"pilotly-home-profile" + (active === 'profile' ? " active" : "")}>
									<Link to='/profile' className='noselect'> {userIcon} </Link>
								</div>
							</div>
							<div className="pilotly-home-body">
								<Errors errors={this.state.errors} onClose={() => this.closeMessages()} />
								<div className="pilotly-home-welcome">
									<div className="pilotly-home-welcome-text">
										{welcomeMessage}
									</div>
									<div className="pilotly-home-welcome-icon">
										{/* <img className='pilotly-home-welcome-icon-image' src={happyDayIcon} alt='Welcome' /> */}
									</div>
								</div>
							</div>
							<div className={"pilotly-home-footer" + (this.state.confirmSignOutVisible ? " pilotly-confirm-visible" : "")}>
								<div className="pilotly-home-footer-default">
									<div className="pilotly-home-footer-links">
										<Link to='/terms-and-conditions' className='noselect'>
											<FormattedMessage
												id="home.footer.terms_of_service"
												defaultMessage={"Terms of Service"}
											/>
										</Link>
															&#124;
										<Link to='/privacy-policy' className='noselect'>
											<FormattedMessage
												id="home.footer.privacy_policy"
												defaultMessage={"Privacy Policy"}
											/>
										</Link>
									</div>
									<div className="pilotly-home-footer-sign-out">
										<div onClick={() => this.confirmSignOut()}>
											<img className='pilotly-home-sign-out-image' src={signOutIcon} alt='Sign Out' />
											<span className='pilotly-home-sign-out-text'>
												<FormattedMessage
													id="home.footer.sign_out"
													defaultMessage={"Sign out"}
												/>
											</span>
										</div>
									</div>
								</div>
								<div className={"pilotly-home-footer-confirmation" + (this.state.confirmSignOutVisible ? "" : " display-none")}>
									<div className="pilotly-home-confirmation-text">
										<FormattedMessage
											id="home.footer.sign_out.confirm"
											defaultMessage={"Are you sure?"}
										/>
									</div>
									<div className="pilotly-home-footer-sign-out-buttons">
										<Button className="transparent pilotly-home-footer-sign-out-button pilotly-home-footer-sign-out-button-no" onClick={() => this.cancelSignOut()}>
											<span className='pilotly-home-sign-out-text'>
												<FormattedMessage
													id="home.footer.sign_out.confirm.no"
													defaultMessage={"No"}
												/>
											</span>
										</Button>
										<Button className="pilotly-home-footer-sign-out-button pilotly-home-footer-sign-out-button-yes" onClick={() => this.signOut()}>
											<span className='pilotly-home-sign-out-text'>
												<FormattedMessage
													id="home.footer.sign_out.confirm.yes"
													defaultMessage={"Yes"}
												/>
											</span>
										</Button>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div className="pilotly-home-right">
						{content}
					</div>
				</div>
			</FadeIn>
		);
	}
}

function mapStateToProps(state) {
	return {
		currentUser: state.currentUser.currentUser,
		fetchedDistributionList: state.targetProcess.fetchedDistributionList,
		fetchedGroup: state.targetProcess.fetchedGroup,
		targetParams: state.targetProcess.targetParams,

		userMonitor: state.currentUser.userMonitor,
		pilotlyPoints: state.currentUser.userPilotlyPoints,
		activityList: state.homeLists.activityList,
		activityListTimestamp: state.homeLists.activityListTimestamp,
		tracker: state.GlobalAnalyticsAdapterReducer.gaTracker,
		globalAnalyticsAdapter: state.GlobalAnalyticsAdapterReducer.globalAnalyticsAdapter,
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
		setCurrentUser,
		setActivityList,
		setMyList,
		setPilotlyPoints,
		setUserMonitor,

		setTargetParams,
		setFetchedDistributionList,
		setFetchedGroup,
		setFetchedGroupPanelSegment,
		setFetchedEpisode
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Home));



// WEBPACK FOOTER //
// ./src/pages/Home.js